<div class="inventory-card">
  <div class="card-header">
    <app-title-field class="inventory-title-field" [title]="'Accessories Management'" [icon]="'inventory'" [iconColour]="'#1A1A1A'" [iconVariant]="'outlined'"
      [showLink]="true" (click)="navigateToInventoryTab()"></app-title-field>

    <div class="dropdown-group parent-dropdown-width">
       <app-dropdown [label]="'Select Month'" [options]="monthOptions" [(ngModel)]="selectedMonthValue" [valueKey]="'value'"
         [displayKey]="'label'" (dropdownChange)="handleMonthChange($event)" [preSelectedValue]="selectedMonth">
       </app-dropdown>
      <app-dropdown [options]="locationOptions" [label]="'Location'" [displayKey]="'label'" [valueKey]="'value'"
        [(ngModel)]="selectedLocation" (dropdownChange)="onLocationChange($event)">
      </app-dropdown>
    </div>
  </div>
  <div *ngIf="isLoading" class="card-loading-overlay">
    <div class="card-spinner">
      <div class="spinner"></div>
      <span class="loading-text">Loading...</span>
    </div>
  </div>

  <div *ngIf="!isLoading && isChartReady else noDataTemplate"
       class="chart-and-summary_inventory">
    <app-chart
      [data]="donutChartData"
      [type]="chartType"
      [labelKey]="chartLabelKey"
      [valueKey]="chartValueKey"
      [applyColorMap]="false"
      [height]="250"
      [width]="250"
      ariaLabel="Inventory distribution by item">
    </app-chart>
    <div class="custom-legend" *ngIf="isChartReady && legendItems.length">
      <div class="summary-header">
        <span class="col-asset">Item Name</span>
        <span class="col-number">Quantity</span>
      </div>
      <ng-container *ngFor="let item of legendItems">
        <div class="legend-item" *ngIf="item.value !== 0">
          <div class="legend-header">
            <span class="legend-box" [style.backgroundColor]="item.color"></span>
            <span class="legend-label">{{ item.label }}</span>
            <span class="legend-value">{{ item.value }}</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <ng-template #noDataTemplate>
    <section class="records-container" aria-label="Records section">
      <div class="empty-state">
        <ng-container *ngIf="isDataLoaded">
          <h3 class="empty-state-title">{{ errorMsg }}</h3>
        </ng-container>
        <img [src]="imageSrc" alt="No records illustration" class="empty-state-image" />
      </div>
    </section>
  </ng-template>
</div>